<template>
  <div>
    <!-- <pre>
      dates: {{ dates }}
    </pre>
    sites: {{ sites }}<br />
    partnerViews: {{ partnerViews }} -->

    <v-container v-if="loading" class="text-center">
      <v-progress-linear color="primary" indeterminate></v-progress-linear>
    </v-container>

    <v-card
      v-else-if="
        partnersViews.length === 0 ||
        ('data' in partnersViews[0] && partnersViews[0]['data'].length === 0)
      "
    >
      <v-card-text>{{ noDataText }}</v-card-text>
    </v-card>
    <div v-else>
      <div v-for="(partnerViewSeries, index) in partnersViews" :key="index">
        <div v-if="partnersViewsIsVisible[index]">
          <v-card class="mt-4">
            <v-card-title> {{ partnerViewSeries.name }} </v-card-title>
            <v-card-subtitle>
              Total CA:
              <span class="text-ca">{{ partnerViewSeries.total_ca }} €</span>
            </v-card-subtitle>
            <vue-apex-charts
              type="line"
              :height="height"
              :options="chartOptions"
              :series="partnerViewSeries.series"
              class="px-6"
            ></vue-apex-charts>
          </v-card>
        </div>
      </div>
      <v-row
        v-if="lastSitesSerieIsVisibleIndex < partnersViews.length - 1"
        class="mt-5"
      >
        <v-col cols="3">
          Chargement du graph {{ lastSitesSerieIsVisibleIndex + 1 }} /
          {{ partnersViews.length }}
        </v-col>
        <v-col cols="9">
          <v-progress-linear
            color="primary"
            :value="
              100 * ((lastSitesSerieIsVisibleIndex + 1) / partnersViews.length)
            "
            class="mt-5"
          ></v-progress-linear>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import debounce from "lodash/debounce";
import VueApexCharts from "vue-apexcharts";

import axios, { cacheTime } from "@axios";
import { mdiAlert, mdiEye } from "@mdi/js";

import { colors, noDataText } from "@/utils/constants";
import { formatNumber, prettyNbs } from "@/utils/formatting";
import {
  getDaysArray,
  getMondaysArray,
  getFirstOfMonthsArray,
} from "@/utils/dates";

export default {
  name: "CaByPartnerViewDateRangeSeparatedChart",
  components: {
    VueApexCharts,
  },
  props: {
    dates: {
      type: Array,
      default: () => [],
    },
    // partnerViews: {
    //   type: Array,
    //   default: () => [],
    // },
    // sites: {
    //   type: Array,
    //   default: () => [],
    // },
    frequency: {
      type: String,
      default: "daily",
    },
  },
  created() {
    this.debouncedGetData();
  },
  data() {
    return {
      icons: {
        mdiAlert,
        mdiEye,
      },
      partnersViews: [],
      partnersViewsIsVisible: [],
      lastSitesSerieIsVisibleIndex: 0,
      noDataText: null,
      loading: false,
      title: "",
      legend: true,
      colorCA: colors.ca,
      colors: [colors.ca],
      stroke: {
        show: true,
        curve: "smooth",
        width: 2,
        dashArray: [], // 0, 2
      },
      height: 300,
      labelsEnabled: false,
      yAxis: [
        {
          title: {
            text: "Revenue",
          },
          seriesName: "Revenue",
          min: 0,
          forceNiceScale: true,
          labels: {
            formatter: (val) => formatNumber(val),
          },
        },
      ],
      xAxis: {
        categories: [],
        labels: {
          rotate: -45,
        },
        style: {
          fontSize: "12px",
          fontWeight: 400,
        },
      },
      chartOptions: {
        chart: {
          type: "line",
          zoom: {
            enabled: false,
          },
        },
        markers: {
          size: 0,
          hover: {
            sizeOffset: 6,
          },
        },
        grid: {
          borderColor: "#f1f1f1",
        },
      },
    };
  },
  methods: {
    debouncedGetData: debounce(async function () {
      await this.getData();
    }, 500),
    async getData() {
      //try {
      if (this.dates.length !== 2) {
        return;
      }
      const queryParams = {
        date_start: this.dates[0],
        date_end: this.dates[1],
        period_group_type: this.frequency,
        ...(this.sites && this.sites.length > 0
          ? { sites: this.sites.join(",") }
          : {}),
        ...(this.partnerViews && this.partnerViews.length > 0
          ? { partner_views: this.partnerViews.join(",") }
          : {}),
      };
      this.loading = true;
      const response = await axios.get("/programmatic/ca-by-partner-view", {
        params: queryParams,
        cache: {
          maxAge: cacheTime,
        },
      });
      this.loading = false;
      if (!response.data || response.data.length === 0) {
        console.warn("No data available from the response");
        this.noDataText = noDataText;

        return;
      }
      const partnerViewsData = response.data;
      //console.log("partnerViewsData", partnerViewsData);

      let categories;
      switch (this.frequency) {
        case "weekly":
          categories = getMondaysArray(this.dates[0], this.dates[1]);
          break;
        case "monthly":
          categories = getFirstOfMonthsArray(this.dates[0], this.dates[1]);
          break;
        default: // daily
          categories = getDaysArray(this.dates[0], this.dates[1], true);
          break;
      }

      //console.log("categories", categories);
      // categories = this.addMonthBoundariesToDateList(categories);

      this.fillPeriodData(categories, partnerViewsData);
      //console.log("partnerViewsData 2", partnerViewsData);
      this.fillMonthData(categories, partnerViewsData, this.frequency);

      // categories = categories.map((dateStr) => new Date(dateStr).getTime());
      if (this.frequency == "weekly") {
        categories = categories.map((dateStr) => `Semaine du ${dateStr}`);
      } else if (this.frequency == "monthly") {
        categories = categories.map((dateStr) => dateStr.slice(0, 7));
      }

      const annotations = {
        xaxis: [
          {
            x: "annotations xaxis.0 x",
            borderColor: "#FF0000",
            fillColor: "#FF0000",
            opacity: 0.6,
            label: {
              // borderColor: "#333",
              // style: {
              //   fontSize: "10px",
              //   color: "#333",
              //   background: "#FEB019",
              //   minWidth: "200px",
              //   minHeight: "80px",
              // },
              text: "xaxis.0 text",
            },
          },
        ],
      };

      this.chartOptions = {
        ...this.chartOptions,
        chart: {
          ...this.chartOptions.chart,
          id: this.title,
          height: this.height,
        },
        annotations: annotations,
        legend: {
          show: this.legend,
        },
        colors: this.colors,
        dataLabels: {
          enabled: this.labelsEnabled,
        },
        //stroke: this.stroke,
        stroke: {
          width: [2, 1, 2, 1],
          show: true,
          curve: "smooth", //"straight",
          dashArray: [0, 2, 0, 2],
        },
        xaxis: {
          categories: categories,
          //type: "datetime",
          labels: {
            rotate: -45,
          },
          style: {
            fontSize: "12px",
            fontWeight: 400,
          },
        },
        yaxis: this.yAxis,
      };
      /*
        partnerViewsData = [
          {
            name: "mysite A"
            series: [
              { name: "CA", data: [5, 15, 18, ...] },
              { name: "CA Objectives", data: [21, 21, 21, ...] },
              { name: "Sessions", data: [300, 1100, 1005, ...] },
              { name: "Sessions Objectives", data: [553, 553, 553, ...] }
            ],
          },
          {
            name: "mysite B"
            series: [
              { name: "CA", data: [6, 9, 15, ...] },
              { name: "CA Objectives", data: [12, 12, 12, ...] },
              { name: "Sessions", data: [7865, 6358, 741, ...] },
              { name: "Sessions Objectives", data: [6874, 6874, 6874, ...] }
            ],
          },
          ...
        ];
        */
      // if (true) {
      //   // pendant les tests
      //   this.partnersViews = this.partnerViewsDataToSeries(partnerViewsData).slice(0, 1);
      //   return;
      // }
      this.partnersViews = this.partnerViewsDataToSeries(partnerViewsData);
      this.displayGraphsOneByOne();
      // } catch (error) {
      //   console.error("Error loading chart data:", error);
      //   this.noDataText = "Error loading data";
      // }
    },
    async displayGraphsOneByOne() {
      for (let i = 0; i < this.partnersViews.length; i++) {
        this.partnersViewsIsVisible.push(false); // Initialize all graphs as hidden
      }
      for (let i = 0; i < this.partnersViews.length; i++) {
        await this.delayGraphDisplay(i); // Introduce a delay before showing each graph
        this.$set(this.partnersViewsIsVisible, i, true); // Display the graph one by one
        this.lastSitesSerieIsVisibleIndex = i;
      }
    },
    delayGraphDisplay(index) {
      return new Promise((resolve) => {
        setTimeout(resolve, 300 * index); // Adjust 300ms for desired delay
      });
    },
    partnerViewsDataToSeries(partnerViewsData) {
      return partnerViewsData.map((partnerView) => {
        return {
          name: partnerView.label,
          total_ca: prettyNbs(Math.round(partnerView.total_ca)),
          series: [{ name: "CA", data: partnerView.period_ca_complete_array }],
        };
      });
    },
    calculateWeeklyAverages(monthlyData) {
      const getDaysInMonth = (year, month) =>
        new Date(year, month + 1, 0).getDate();
      const weeklyAverages = {};
      for (const [date, value] of Object.entries(monthlyData)) {
        const [year, month] = date.split("-").map(Number);
        const daysInMonth = getDaysInMonth(year, month - 1); // Month - 1 because Date months are 0-indexed
        const weeksInMonth = daysInMonth / 7;
        weeklyAverages[`${year}-${String(month).padStart(2, "0")}`] =
          value / weeksInMonth;
      }
      return weeklyAverages;
    },
    fillPeriodData(dateRange, partnerViewsData) {
      // this function is meant to fill match a value for each day of the dateRange or null
      partnerViewsData.forEach((partnerView) => {
        Object.keys(partnerView).forEach((prop) => {
          if (
            prop.includes("period") &&
            typeof partnerView[prop] === "object" &&
            partnerView[prop] !== null &&
            !Array.isArray(partnerView[prop])
          ) {
            const newPropName = `${prop}_complete_array`;
            partnerView[newPropName] = dateRange.map((date) =>
              date in partnerView[prop] ? partnerView[prop][date] : null
            );
          }
        });
      });
    },
    fillMonthData(dateRange, partnerViewsData, periodType) {
      // this function is meant to fill match a value for each day of the dateRange or null
      partnerViewsData.forEach((partnerView) => {
        Object.keys(partnerView).forEach((prop) => {
          if (
            prop.includes("monthly") &&
            typeof partnerView[prop] === "object" &&
            partnerView[prop] !== null &&
            !Array.isArray(partnerView[prop])
          ) {
            const newPropName = `${prop}_complete_array`;
            //console.log(`partnerView ${partnerView} ${prop} partnerView[prop]`, partnerView[prop]);

            let monthlyData = partnerView[prop];
            //console.log(`partnerView ${partnerView.name} ${prop} monthlyData 1`, monthlyData);
            if (periodType == "daily" || periodType == "monthly") {
              monthlyData = Object.fromEntries(
                Object.entries(monthlyData).map(([key, value]) => [
                  key.slice(0, 7),
                  value,
                ])
              );
            } else if (periodType == "weekly") {
              monthlyData = this.calculateWeeklyAverages(monthlyData);
            }

            // console.log(`partnerView ${partnerView.name} ${prop} monthlyData 2`, monthlyData);
            // console.log("dateRange", dateRange);

            partnerView[newPropName] = dateRange.map((date) => {
              const month = date.slice(0, 7); // Extract 'YYYY-MM' from date
              if (month in monthlyData) {
                let periodValue = null;
                if (periodType == "daily" || periodType == "monthly") {
                  // Calculate the number of days in the month
                  const [year, monthNum] = month.split("-").map(Number);
                  const daysInMonth = new Date(year, monthNum, 0).getDate();
                  // Divide the monthly value by the number of days
                  periodValue = monthlyData[month] / daysInMonth;
                } else {
                  periodValue = monthlyData[month];
                }
                return Math.round(periodValue);
              } else {
                return null;
              }
            });
          }
        });
      });
    },
  },
  computed: {
    sites() {
      return this.$store.getters["premium/getSites"];
    },
    partnerViews() {
      return this.$store.getters["premium/getPartnerViews"];
    },
  },
  watch: {
    // dates: function () {
    //   if (!(this.dates && this.dates.length === 2)) {
    //     console.warn(
    //       "CaByPartnerViewDateRangeSeparatedChart missing prop dates",
    //       this.dates
    //     );
    //     return;
    //   }
    //   this.debouncedGetData();
    // },
  },
};
</script>
<style>
.text-ca {
  color: #feb019;
}
.text-sessions {
  color: #008ffb;
}
</style>
